import { Pinia } from 'pinia'
import { useLayerStore } from './layer'

// 组件内使用不需要传pinia，组件外使用需要传pinia
export const viewerStore = {
  useLayerStore: (pinia?: Pinia) => useLayerStore(pinia),
}